// src/Nl.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Nl_default = createIcon({
  displayName: "Nl",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        id: "white",
        x: "1",
        y: "12",
        width: "48",
        height: "10",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("rect", {
        id: "red",
        x: "1",
        y: "1",
        width: "48",
        height: "11",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("rect", {
        id: "blue",
        x: "1",
        y: "22",
        width: "48",
        height: "11",
        fill: "#0070B8"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      })
    ]
  })
});

export {
  Nl_default
};
